<script>
    import Banner from '../components/Banner.svelte'
    import QueryString from 'query-string'
    import {emitPageViewEvent} from '../actions/pageAnalytics'

    window.scrollTo(0, 0)
    export let location
    emitPageViewEvent(location,'Error')
    const queryParams = QueryString.parse(location.search)
    let errorMessage = queryParams.message ? queryParams.message : 'An error has occurred.'
</script>

<style>
    .pageContent {
        max-width: 360px;
    }
</style>
<div class="flex flex-column relative">
    <div class="pageContent flex flex-column mt2 mb4 self-center items-center">
        <Banner cl='error self-stretch'>{errorMessage}</Banner>
    </div>
</div>
